import React                     from 'react';
import classnames                from 'classnames';
import { FontAwesomeIcon }       from '@fortawesome/react-fontawesome';

const BomQuantities = (props) => {
  return(
    <div className="d-flex align-items-center board-quantities" >
      <div className="label text-center me-2">
        Board Quantities
      </div>
      {props.quantities.map((quantity) => (
        <div className="me-1" key={quantity}>
          <button type="button" onClick={e => props.onChangeNumBoard(quantity)}
           className={`px-3 btn btn-sm btn-block btn-quantity ${(quantity == props.selected_quantity) ? "active" : ""}`}>
            {quantity}
          </button>
        </div>
      ))}
    </div>
  )
}

export default BomQuantities;